import CONFIG from "@/assets/js/config.js";

export const NRCService = {
    /**
     * splitNRCNumbers splits the NRC number into its components: region code(12), township code(katata), citizen code(N), and number.
     * @param {string} nrcNumber 
     * @returns {Object} {regionCode: string, townshipCode: string, citizenCode: string, number: string}
     */
    splitNRCNumbers(nrcNumber) {
        let nrcFormat = {
            'regionCode': '',
            'townshipCode': '',
            'citizenCode': '',
            'number': nrcNumber
        }

        if (!nrcNumber) return nrcFormat;
        let parts = nrcNumber.split('/');

        if (parts.length !== 2) return nrcFormat;

        nrcFormat.regionCode = parts[0].trim().replace(/\D/g, '');
        let townshipParts = parts[1].split('(');
        if (townshipParts.length < 2) {
            nrcFormat.number = townshipParts[0].trim();
            return nrcFormat
        }

        nrcFormat.townshipCode = townshipParts[0].trim();
        let citizenCodeParts = townshipParts[1].split(')');
        if (citizenCodeParts.length < 2) {
            nrcFormat.number = citizenCodeParts[0].trim();
            return nrcFormat
        }

        nrcFormat.citizenCode = citizenCodeParts[0].trim();
        nrcFormat.number = citizenCodeParts[1].trim();

        return nrcFormat;
    }, 

    /**
     * convertTownshipCodeToMM converts the region code and township code from English to Myanmar script.
     * 12 = ၁၂, katata = ကတတ
     * @param {string} regionCode 
     * @param {string} townshipCode 
     * @returns {string} townshipCode in Myanmar script
     */
    convertTownshipCodeToMM(regionCode, townshipCode) {
        townshipCode = townshipCode.toLowerCase();
        const ENG_TO_MM_CHARS = CONFIG.ENG_TO_MM_CHARS;
        let result = [""];
    
        let i = 0;
        while (i < townshipCode.length) {
            let matched = false;
    
            for (let len = 3; len > 0; len--) {
                let slice = townshipCode.slice(i, i + len);
                if (ENG_TO_MM_CHARS[slice]) {
                    const options = ENG_TO_MM_CHARS[slice].split(",");
                    const newResult = [];
                    for (const prefix of result) {
                        for (const opt of options) {
                            newResult.push(prefix + opt);
                        }
                    }
                    result = newResult;
                    i += len;
                    matched = true;
                    break;
                }
            }
            if (!matched) {
                i++;
            }
        }
        // Filter only valid townships in NRC TOWNSHIP for the given region code
        const validTownships = CONFIG.NRC.TOWNSHIP[regionCode] || [];
        const filtered = result.filter(r => validTownships.includes(r));

        return filtered.length > 0 ? filtered[0] : "";
    },

    /**
     * convertCitizenshipToMM converts the citizenship code from English to Myanmar script.
     * n => (နိုင်)
     * naing => (နိုင်)
     * eain => (ဧည့်)
     * ei => (ဧည့်)
     * pyu => (ပြု)
     * @param {string} code 
     * @returns {string} citizenship code in Myanmar script
     */
    convertCitizenshipToMM(code) {
        if (!code) return "";
        const CITIZEN_CODES_MAP = CONFIG.CITIZEN_CODES_MAP;
        code = code.toLowerCase().trim();
        return CITIZEN_CODES_MAP[code] || code;
    },
}
